import { createApiClient } from '@moneytome/shared';
import { i18n } from '../shared/i18n';

// Promo-landing needs only the public onboarding endpoint; it still uses the
// shared client boundary (correlation id, error mapping, no sensitive logging).
// No auth token on the public surface.
//
// basePath is the backend's anonymous API surface as served by the service
// itself (`ApiSurfaces.PUBLIC` = /api/public). Stage exposes each backend
// service on its own host (s-marketplace.moneyto.me) with no prefix-rewriting
// gateway, so the `/api` segment has to be on the wire here.
export const api = createApiClient({
  baseURL: import.meta.env.VITE_API_URL,
  basePath: '/api/public',
  getToken: () => null,
  getLanguage: () => i18n.language,
  refreshToken: async () => false,
  onAuthFailure: () => {},
});
